import '../../../../dmView/style/App.css';
import {useState, useEffect} from 'react';
import { levelData, getImageUrl, getLevelData, effectImgMap, conditionImgMap, addSign} from '../../../constants';
import SkillGrid from '../../SkillGrid';
import ContentString from '../ContentString';
import { BoldifyReplace } from '../BoldifyReplace';
import SpellCastingPdf from './SpellCastingPdf';
import LairActionsPdf from './LairActionsPdf';

const changeName = window.location.search.includes("becca"); // Query string

function exists(value) {
    return value && value !== '0';
}

function formatSpeed(speed) {
    if(!speed) {
        speed = {'walk': 30}
    }
    const order = changeName ? ['walk'] : ['walk', 'climb', 'burrow', 'swim', 'fly', 'hover'];
    const entries = order
        .filter(key => exists(speed[key])) 
        .map(key => [key, speed[key]]);
    
    const result = entries
        .map(([key, value], i, arr) => `${capsFirstLetter(key)}${key !== 'hover' ? ` ${value}` : ''}${i < arr.length - 1 ? ', ' : ''}`)
        .join('');
    
    // If no speed greater then 0 exists
    if(result.length === 0)
        return 'None'

    return result;
}

function capsFirstLetter(word) {
    if (!word)
        return ''; // Handle empty or undefined input
    return word.charAt(0).toUpperCase() + word.slice(1);
}

const CreatureInfo = ({creature}) => {
    let string = ``

    if(creature.size && creature.size !== '--') {
        string += `${creature.size} -`
    }

    if(creature.creature_type && creature.creature_type !== '--') {
        string += ` ${creature.creature_type}`
    }
    
    if(creature.subtype && creature.subtype !== '--') {
        string += ` (${creature.subtype})`
    }

    if(creature.group && creature.group !== "null" && creature.group !== '--') {
        string += ` (${creature.group})`
    } 
    
    if(creature.creature_alignment && creature.creature_alignment !== '--') {
        string += ` (${creature.creature_alignment})`
    }

    if(creature?.alignment) {
        string += ` (${creature.alignment})`
    }

    return <p><i>{string}</i></p>
}

const colors = {
    0: "green",
    1: "orange",
    2: "brown",
}

const StatBlockPdf = ({selectedIndex, indexOf, currentEncounter, pdf}) => {
    
    // Creature can be null from SearchColumn but not from EncounterColumn, Statblock is not shown if from EncounterColumn
    const [creature, setCreature] = useState(currentEncounter?.creatures[selectedIndex])
    const [creatureReset, setCreatureReset] = useState(currentEncounter?.creatures[selectedIndex])

    useEffect(() => {
        if(creature?.avatarUrl === null) {
            const setCreatureImage = async () => {
                let avatarUrl = await getImageUrl(creature.name, creature.creature_type)
                setCreature({...creature, avatarUrl})
            }

            setCreatureImage()
            
        }
    }, [creature])

    // If selectedIndex changes a new creature was clicked
    useEffect(() => {
        let newCreature = selectedIndex !== null ? currentEncounter?.creatures[selectedIndex] : null
        setCreature(newCreature)

        //only change creatureReset if its actually since this useeffect trigger on cancel
        if(newCreature.creatureGuid !== creatureReset.creatureGuid)
            setCreatureReset(newCreature)
        
    // eslint-disable-next-line
    }, [currentEncounter?.creatures[selectedIndex], selectedIndex]);

    return (
        <div className='infoContainer'>
            <>  
                <div className='quickStatsPdf'>
                    <div className='topInfoPdf shadowBox'>
                        <img className={'behindImage'} src={creature.avatarUrl} alt={"Creature Img"} />
                        <>
                            <h1 className='creatureName titleFontFamily'>{creature?.name}&nbsp;</h1>
                            
                            <div className='creatureType'>
                                <hr className="lineSeperator" />
                                <CreatureInfo creature={creature} />
                                {(currentEncounter.encounterName !== 'dmbuddy_selected' && currentEncounter.encounterName !== 'dmbuddy_newhomebrew' && indexOf !== undefined) && 
                                    <div className='selectedIndicater siStatBlock' style={{backgroundColor: colors[indexOf]}}> {indexOf+1}</div>
                                }    
                            </div>
                            {creature.effectObjs.length > 0 &&
                                <div style={{backgroundColor: "black", width: 'fit-content', height: '42px', borderRadius: 5}}>
                                    {creature.effectObjs.map((effect) => {
                                        const effectName = effect.effectName;
                                        return (
                                            <img key={effectName} alt='effect' className='effect growImage' src={effectImgMap[effectName] || conditionImgMap[effectName]}/>
                                        )
                                    })}
                                </div>
                            }
                            <div className='stickyStatGrid textShadow' >
                                <p className="stickyStatItem">
                                    <strong className='titleColor'>{changeName ? 'Max MP' : 'AC'}&nbsp;</strong>
                                    <BoldifyReplace desc={creature.armor_class} />
                                    {creature.armor_desc && creature.armor_desc !== "()" && creature.armor_desc !== "null" && creature.armor_desc !== "(null)" && 
                                        <>&nbsp;<BoldifyReplace desc={creature.armor_desc} /></>
                                    } 
                                </p>
                                <p className="stickyStatItem">
                                    <strong className='titleColor'>Initiative</strong>&nbsp;{addSign(Math.floor((creature.dexterity-10)/2))} 
                                    <span className='extraInfo'>&nbsp;({parseInt(creature.dexterity_save)+10 || 10})</span>
                                </p>
                                <p className="stickyStatItem stickyStatExtraWide">
                                    <strong className='titleColor'>HP&nbsp;</strong>{creature.hit_points}
                                    {creature.hit_points_temp !== 0 && (
                                        <span className='tempHp'>&nbsp;(+{creature.hit_points_temp}) </span>
                                    )}
                                    {creature.hit_points_formula && creature.hit_points === creature.hit_points_default && (
                                        <span className='extraInfo'>&nbsp;({creature?.hit_points_formula})</span>
                                    )}
                                </p>
                                {creature.hit_points_special && 
                                <>
                                    {/* This is for spacing */}
                                    <p className="stickyStatItem"/>
                                    <p className="stickyStatItem stickyStatExtraWide">
                                        <strong className='titleColor'><i>HP Special&nbsp;</i></strong>
                                        <span className='extraInfo'>{creature.hit_points_special}</span>
                                    </p>
                                </>
                                    
                                }
                                {/* This is for spacing */}
                                <p className="stickyStatItem"/>

                                <p className="stickyStatItem stickyStatExtraWide">
                                    <strong className='titleColor'>Speed</strong>&nbsp;
                                    {formatSpeed(creature.speed)}
                                </p>
                                <p className="stickyStatItem"></p>
                            </div>
                            <SkillGrid creature={creature} handleChange={() => {}}/>
                        </>
                    </div>
                    <div>
                        <ContentString label={'Skills'} contentString={creature.skills} />
                        <ContentString label={'Vulnerabilities'} contentString={creature.damage_vulnerabilities} />
                        <ContentString label={'Resistances'} contentString={creature.damage_resistances} />
                        <ContentString label={'Immunities'} contentString={creature.damage_immunities} />
                        <ContentString label={'Condition Immunities'} contentString={creature.condition_immunities?.split(', ').filter(str => str.trim() !== "").map((c) => {return `{@condition ${c}}`}).join(', ')} />
                        <ContentString label={'Senses'} contentString={creature.senses} />
                        <ContentString label={'Languages'} contentString={creature.languages} />
                        <div style={{display: 'flex'}}>
                            <ContentString label={'CR'} contentString={creature.challenge_rating} italics={`${parseInt(creature.challenge_rating) > 30 ? '' : `(${getLevelData(creature.challenge_rating)} XP)`}`}/>
                            <ContentString label={'Prof.'} contentString={creature.prof_bonus || levelData[creature?.challenge_rating]?.profBonus || null} hoverTitle={'Prof. Bonus is determined by CR and can be edited by the DM'} addPlus={true}/>
                        </div>
                        <div className='playerChecksGridPdf'>
                            <div>
                                <div>
                                    <b className="checkDivLabel">Strength</b>

                                    <div className="checksDiv">
                                        Athletics <div className="checkBox"/>
                                    </div>
                                </div>
                                
                                <div>
                                    <b className="checkDivLabel">Dexterity</b>

                                    <div className="checksDiv">
                                        Acrobatics <div className="checkBox"/>

                                    </div>
                                    <div className="checksDiv">
                                        Sleight of Hand <div className="checkBox"/>

                                    </div>
                                    <div className="checksDiv">
                                        Stealth <div className="checkBox"/>

                                    </div>  
                                </div>
                            </div>
                            <div>
                                <b className="checkDivLabel">Intelligence</b>

                                <div className="checksDiv">
                                    Arcana <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    History <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Investigation <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Nature <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Religion <div className="checkBox"/>
                                </div>
                            </div>
                            <div>
                                <b className="checkDivLabel">Wisdom</b>
                                
                                <div className="checksDiv">
                                    Animal Handling <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Insight <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Medicine <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Perception <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Survival <div className="checkBox"/>
                                </div>
                            </div>
                            <div>
                                <b className="checkDivLabel">Charisma</b>

                                <div className="checksDiv">
                                    Deception <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Intimidation <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Performance <div className="checkBox"/>
                                </div>
                                <div className="checksDiv">
                                    Persuasion <div className="checkBox"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="statBlockScrollPdf">
                    <LairActionsPdf content={creature.actions} label={'ACTIONS'} cKey={'actions'} handleSlotRecharge={() => {}}/>
                    <LairActionsPdf content={creature.bonus_actions} label={'BONUS ACTIONS'} cKey={'bonus_actions'} handleSlotRecharge={() => {}}/>
                    <LairActionsPdf content={creature.reactions} label={'REACTIONS'} cKey={'reactions'} handleSlotRecharge={() => {}}/>
                    <LairActionsPdf content={creature.special_abilities} label={'TRAITS'} cKey={'special_abilities'} handleSlotRecharge={() => {}}/>
                    <SpellCastingPdf creature={creature}/>
                    <LairActionsPdf content={creature.inventory} label={'INVENTORY'} cKey={'inventory'} />
                    <LairActionsPdf content={creature.legendary_actions} label={'LEGENDARY ACTIONS'} cKey={'legendary_actions_count'} labelDesc={creature.legendary_desc} actions_count={creature.legendary_actions_count} handleSlotRecharge={() => {}} />
                    <LairActionsPdf content={creature.mythic_actions} label={'MYTHIC ACTIONS'} cKey={'mythic_actions'} labelDesc={creature.mythic_desc} />
                    <LairActionsPdf content={creature.lair_actions} label={'LAIR ACTIONS'} cKey={'lair_actions'} handleSlotRecharge={() => {}}/>
                    <LairActionsPdf content={creature.regional_effects} label={'REGIONAL EFFECTS'} cKey={'regional_effects'} handleSlotRecharge={() => {}}/>
                </div>
                {creature.sourceShort && 
                    <div>
                        <hr className="lineSeperator lineSeperatorLast" />
                        <hr className="lineSeperator" />
                        <strong className='source'>Source: {creature.sourceShort}, page {creature.page}</strong>
                    </div>
                }
            </>
        </div>
    );
}

export default StatBlockPdf;
